import React from 'react';

const CSS = require('./MenuDivider.module.scss');

function MenuDivider() {
  return <hr className={CSS.MenuDivider} />;
}

export default MenuDivider;
